<template>
  <h1>VUEX - playground</h1>
  <VuexPlayground/>
</template>

<script>
import VuexPlayground from './components/VuexPlayground.vue'

export default {
  name: 'App',
  components: {
    VuexPlayground
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
